(() => {
    HuiNavController.$inject = ['$scope'];

    function HuiNavController($scope) {
        const self = this;
    }

    angular
        .module("harriApp")
        .directive("huiNav", function () {
            return {
                restrict: 'E',
                replace: true,
                scope: true,
                transclude: true,
                bindToController: {
                    classNames: '<',
                    onMouseEnter: '&',
                    onMouseLeave: '&',
                },
                controllerAs: '$ctrl',
                controller: HuiNavController,
                templateUrl: `../hmodules/harri-main/ui-components/hui-nav.html`
            }
        });

})();